module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 21
// module chunks = 0